import Util from "ips/ac/util/Util";
import HttpUtil from "ips/ac/util/HttpUtil";
import Response from "ips/ac/model/types/Response";
import { UserDto } from "ips/ac/model/api/WinDoFlow.api.types";
import UserClassObj from "ips/ac/util/classes/user/User";
import JSONModel from "sap/ui/model/json/JSONModel";
import Filter from "sap/ui/model/Filter";
import FilterOperator from "sap/ui/model/FilterOperator";
import ODataListBinding from "sap/ui/model/odata/v4/ODataListBinding";

export default class UserService {
  /*  activate user */
  public static activate(userGuid: string): Promise<void> {
    const url = UserService.getBaseUrl() + "/activate";
    const payload = { guids: [userGuid] };
    return HttpUtil.post(url, null, payload);
  };

  /*  deactivate user */
  public static deactivate(userGuid: string): Promise<void> {
    const url = UserService.getBaseUrl() + "/deactivate";
    const payload = { guids: [userGuid] };
    return HttpUtil.post(url, null, payload);
  };

  /* load current user */
  public static async loadCurrentUser(): Promise<UserClassObj> {
    //base url is not yet available when this method is called
    const response: Response<UserDto> = await HttpUtil.get("/IpsCore/private/service/user");
    const userDto = response.content;

    const user = UserClassObj.getInstance();
    user.setData(userDto);

    return user;
  }

  public static async refreshUsersModel(): Promise<void> {
    const binding = Util.getComponent().getModel().bindList("/Users", null, [], [new Filter("IsActive", FilterOperator.EQ, 1)]) as ODataListBinding;
    const contexts = await binding.requestContexts(0, Infinity);
    const model = new JSONModel(contexts.map((context) => context.getObject()));
    Util.getComponent().setModel(model, "EF");
  }

  /*  get base url */
  private static getBaseUrl(): string {
    return Util.getPrivateApi() + "/user";
  };
}